/**
 * These do not need to be translated -- they should be hard-coded
 * so that they always display in their own language
 */
 import { deDE, enUS, frFR, itIT, jaJP, fiFI, koKR, nlNL, trTR, viVN, esES, zhTW, thTH } from "@mui/material/locale";
 
 const LANGUAGES = {
   // "localization_name" is in i18n folder for each locatization
   en: "English",
   de: "Deutsch",
   fr: "Français",
   it: "Italiano",
   ja: "日本語",
   fi: "suomi",
   ko: "한국어",
   nl: "Nederlands",
   zh: "繁體中文",
   tr: "Türkçe",
   vi: "Tiếng Việt",
   th: "ภาษาไทย",
   es: "Español",
 };
 
 export const APP_LANGUAGES: {
   [key: string]: { full: string; code: string; muiMapping: any };
 } = {
   en: {
     full: LANGUAGES.en,
     code: "en",
     muiMapping: enUS,
   },
   de: {
     full: LANGUAGES.de,
     code: "de",
     muiMapping: deDE,
   },
   fr: {
     full: LANGUAGES.fr,
     code: "fr",
     muiMapping: frFR,
   },
   it: {
     full: LANGUAGES.it,
     code: "it",
     muiMapping: itIT,
   },
   ja: {
     full: LANGUAGES.ja,
     code: "ja",
     muiMapping: jaJP,
   },
   fi: {
     full: LANGUAGES.fi,
     code: "fi",
     muiMapping: fiFI,
   },
   ko: {
     full: LANGUAGES.ko,
     code: "ko",
     muiMapping: koKR,
   },
   nl: {
     full: LANGUAGES.nl,
     code: "nl",
     muiMapping: nlNL,
   },
   th: {
     full: LANGUAGES.th,
     code: "th",
     muiMapping: thTH,
   },
   tr: {
     full: LANGUAGES.tr,
     code: "tr",
     muiMapping: trTR,
   },
   vi: {
     full: LANGUAGES.vi,
     code: "vi",
     muiMapping: viVN,
   },
   zh: {
     full: LANGUAGES.zh,
     code: "zh",
     muiMapping: zhTW,
   },
   es: {
     full: LANGUAGES.es,
     code: "es",
     muiMapping: esES,
   },
 };
 
 enum UserRoles {
   repOrg = "representative",
   admin = "administrator",
   support = "support",
   user = "user",
 }
 
 export const USER_ROLES = {
   admins: [String(UserRoles.repOrg), String(UserRoles.admin)],
   all: [
     String(UserRoles.repOrg),
     String(UserRoles.admin),
     String(UserRoles.support),
     String(UserRoles.user),
   ],
 };
 
 export const USERS_NUMBER = {
   MAX_USERS: 10000,
   MIN_USERS: 0,
 }
 
 export const MAX_APPLICATIONS = 10;
 export const MAX_APPLICATION_FEATURE = 16;
 
 export const TIMEOUT = 15 * 60 * 1000;
 
 export const BRAND_NAMES = {
   KYOCERA: "Kyocera",
   TA: "TA",
 };
 
 export const BRAND_ICONS = {
   [BRAND_NAMES.KYOCERA]: "dev-portal-favicon.png",
   [BRAND_NAMES.TA]: "ta-favicon.png",
};
export const APPID = "CUSTPTL"
export const APP_SHORT_NAME = "CUSTPTL";
export const MAX_DEVICE_COUNT = 1000;

export const DEVICE_FEATURE = "DVCMGMT";
export const STORAGE_FEATURE = "STOREMGMT";
export const PINAUTHCONTROL_FEATURE = "PINAUTHCONTROL";
export const USRPIN_FEATURE = "USRPINAUTH";
export const USRIC_FEATURE = "USRICAUTH";
export const SELF_ACTIVATION_FEATURE = "BULKENROLL";

export const CC_SHORT_NAME = "CC";
export const KCIM_SHORT_NAME = "KCIM";
